module.exports = __webpack_public_path__ + "img/Graziuso-Catello.962c857b.png";